import { useEffect } from 'react';

import { REMOTE_PERMISSIONS } from '@backrs_ui/common-ui';

import { useHasPermission } from './useHasPermission';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { selectOperatorInstitutionId, selectPlatformMode } from '../redux/operatorContext';

/** Naming nothing resolves to the caller's own anchor, which is one operator among many. */
export const useDefaultOperatorContext = (): void => {
  const dispatch = useAppDispatch();
  const canAccessOperatorFleet = useHasPermission(REMOTE_PERMISSIONS.ACCESS_OPERATOR_FLEET);
  const selection = useAppSelector(selectOperatorInstitutionId);
  // A selection carries the account that made it; one stamped before the account lands is disowned.
  const userId = useAppSelector((state) => state.user.user?.id ?? null);

  useEffect(() => {
    if (userId === null || !canAccessOperatorFleet || selection !== null) return;

    dispatch(selectPlatformMode());
  }, [canAccessOperatorFleet, dispatch, selection, userId]);
};
